








































import { Component, Mixins, Watch, Vue } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import appconst from "@/lib/appconst";
import ImportProductApi from "@/api/goods/importProduct/index";
@Component
export default class ProductImport extends AbpBase {
  loading = false;
  templateUrl = "";
  uploadUrl = "";
  pager = {
    pageIndex: 1,
    pageSize: 10,
    total: 0
  };
  columns1 = [
    {
      title: "任务创建时间",
      key: "creationTime",
      slot: "creationTime"
    },
    {
      title: "待同步",
      key: "pendingCount"
    },
    {
      title: "同步中",
      key: "runningCount"
    },
    {
      title: "成功",
      key: "successCount"
    },
    {
      title: "失败",
      key: "failCount"
    },
    {
      title: "任务状态",
      key: "taskStatus"
    },
    {
      title: "备注",
      key: "remark"
    }
  ];
  data1 = [];
  mounted() {
    this.templateUrl = `${appconst.remoteServiceBaseUrl}/api/productManagement/importTask/templateFile`;
    this.uploadUrl = `${appconst.remoteServiceBaseUrl}/api/productManagement/importTask/excel/upload`;
    this.loadData();
  }
  downloadTemplate() {
    location.href = this.templateUrl;
  }
  uploadSuccess() {
    this.$Message.success("上传文件成功，导入比较耗时，请稍后刷新查看结果");
    this.loadData();
  }
  refresh() {
    this.loadData();
  }
  onPageIndexChange(value) {
    this.pager.pageIndex = value;
    this.loadData();
  }
  loadData() {
    this.loading = true;
    ImportProductApi.getList(this.pager.pageSize, this.pager.pageIndex).then(res => {
      this.pager.total = res.data.totalCount;
      this.data1 = res.data.items;
      this.loading = false;
    });
  }
}
